export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: "us-west-2",
    BUCKET: "senasa"
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "http://34.223.251.14/"
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_0vBOn5365",
    APP_CLIENT_ID: "2f3a8p6h584o4mltcnqaotndce",
    IDENTITY_POOL_ID: "us-west-2:d0fa5857-d3a0-48c4-b78e-dfa9b2bab3c3"
  }
};
